import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import * as fromDeleteEmployeesActions from '../actions/delete-employee.actions';
import { IDeleteEmployeesRequest } from '../models/delete.employees.model';

export const deleteEmployeesFeatureKey = 'deleteEmployees';

export interface DeleteEmployeesState {
  loadDeleteEmployees: IDeleteEmployeesRequest;
  loadDeleteEmployeesResponse: string;
  loadDeleteEmployeesFailure: IGenericError<ErrorResponse>;
}

export const initialState: DeleteEmployeesState = {
  loadDeleteEmployees: undefined,
  loadDeleteEmployeesFailure: undefined,
  loadDeleteEmployeesResponse: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromDeleteEmployeesActions.loadDeleteEmployees, (state, action) => ({
    ...state,
    loadDeleteEmployees: action.request,
    loaded: true
  })),
  on(fromDeleteEmployeesActions.loadDeleteEmployeesSuccess, (state, action) => ({
    ...state,
    loadDeleteEmployeesResponse: action.response
  })),
  on(fromDeleteEmployeesActions.loadDeleteEmployeesFailure, (state, action) => ({
    ...state,
    loadDeleteEmployeesFailure: action.error
  }))
);

export const getDeleteEmployeesRequest = (state: DeleteEmployeesState) => state.loadDeleteEmployees;
export const getDeleteEmployeesResponse = (state: DeleteEmployeesState) => state.loadDeleteEmployeesResponse;
export const getDeleteEmployeesFailure = (state: DeleteEmployeesState) => state.loadDeleteEmployeesFailure;
